module.exports = __webpack_public_path__ + "static/media/Nguyen_Manh_Hiep.c14c52b6.jpg";